import { Schema as S } from "effect";
import { apiData } from "../../api/asyncData";
import { Subscription } from "../../api/schemas/billing";
export const Model = S.Struct({
	page: S.Literal("CreditUsage"),
	subscription: apiData(Subscription).schema,
	busy: S.Boolean,
	error: S.Option(S.String),
});
export type Model = typeof Model.Type;
